import { render, staticRenderFns } from "./CachedStatisticsChart.vue?vue&type=template&id=6ef3fde5"
import script from "./CachedStatisticsChart.vue?vue&type=script&lang=js"
export * from "./CachedStatisticsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports